'use client';
import { createContext, useContext } from 'react';
/**
 * Context that carries the zero-based stack index for the current modal.
 *
 * The modal manager wraps each rendered modal in a provider so that the
 * `Modal` component can read its stack position and derive the correct
 * z-index without any prop-drilling.
 */
export const ModalStackContext = createContext(0);
ModalStackContext.displayName = 'ModalStackContext';
/**
 * Returns the zero-based stack index for the current modal.
 *
 * Used internally by `Modal` to compute its z-index from the elevation scale.
 */
export function useModalStackIndex() {
    return useContext(ModalStackContext);
}
//# sourceMappingURL=ModalStackContext.js.map